/**
 * Builds a new instance of the Onboarder App.
 * @module AppController
 * @constructor
 */

/** @lends module:AppController */
function AppController (STRY, ComponentList, ModuleList) {
    if (!STRY) { console.error('StoryStream -> STRY missing.'); return; }
    if (!ComponentList) { console.info('StoryStream -> ComponentList missing.'); return; }
    if (!ModuleList) { console.info('StoryStream -> ModuleList missing.'); return; }
    var scope = document.createElement('div');

    //  Setup scope
    scope.params = {
        version: '0.0.1'
    };
    scope.components = {};
    scope.modules = {};
    scope.services = {};
    scope.ready = STRY ? true : false;
    scope.viewport = {
        is_touch: STRY.util.hasTouchEvents()
    };


    /**
     * Funnel all events through this method and distribute.
     * @memberof AppController
     * @function handleEvent
     * @param {object} e - Event data.
     * @inner
     */
    var handleEvent = function(e, params) {
        var type = e.type ? e.type : false;
        switch(type) {
            case 'viewport.change':

                scope.viewport.is_touch = STRY.util.hasTouchEvents();

                break;
        }
    };


    /**
     * Function to register all components referenced in the document.
     * @memberof AppController
     * @function willRegisterComponents
     * @inner
     */
    var willRegisterComponents = function () {
        var len = ComponentList.length;
        var component;

        while (len--) {
            component = new ComponentList[len]();

            //  Construct instances of components
            if (component.attribute) {

                willInstantiateConstructors(scope.components, component.attribute, ComponentList[len]);
            }
        }
    };


    /**
     * Function to register all modules referenced in the document.
     * @memberof AppController
     * @function willRegisterModules
     * @inner
     */
    var willRegisterModules = function () {
        var len = ModuleList.length;
        var module;

        while (len--) {
            module = new ModuleList[len]();

            //  Construct instances of modules
            if (module.attribute) {

                willInstantiateConstructors(scope.modules, module.attribute, ModuleList[len]);
            }
        }
    };


    /**
     * Function to instantiate and reference and constructors required.
     * @memberof AppController
     * @function willInstantiateConstructors
     * @inner
     */
    var willInstantiateConstructors = function (reference, attribute, constructor) {
        var instances = document.querySelectorAll('[' + attribute + ']');
        var key;
        var len = instances.length;
        var params = {};

        //  Setup reference
        if (!reference[attribute]) {
            reference[attribute] = {};
        }

        //  Create instantiate constructor and unique key
        while (len--) {

            //  Generate a unique instance key
            key = STRY.util.crc32_generate(instances[len].outerHTML);

            //  Add any attributes associated with this instance to the parameters
            params = STRY.util.extractInstanceAttributes(instances[len], attribute);

            //  Add the uniqu key to the parameters
            params.uid = key;

            //  Construct the instance and add to reference
            reference[attribute][key] = new constructor(scope, STRY.util, instances[len], params, new STRY.renderer(scope));
        }
    };


    /**
     * Function to ran after document is ready.
     * @memberof AppController
     * @function whenDocumentHasRendered
     * @inner
     */
    var whenDocumentHasRendered = function () {

        //  Register any page modules
        willRegisterModules();

        //  Register any components
        willRegisterComponents();
    };


    /**
     * Function used to initialise the application.
     * @memberof AppController
     * @function init
     * @inner
     */
    var init = function () {

        // Ensure SDK and any other dependencies are loaded
        if (scope.ready) {

            //  Instantiate components
            whenDocumentHasRendered();

            //  Add listeners
            scope.addEventListener('viewport.change', handleEvent);
        }
    };


    init();
    return scope;
}
if (typeof module !== 'undefined' && exports !== null) {
    exports.AppController = AppController;
}
